import { createAction } from "redux-actions";
import types from "./localTypes";

export const getLocalList = createAction(types.GET_LIST);
export const getLocalListSuccess = createAction(types.GET_LIST_SUCCESS);
export const setLocalFilters = createAction(types.SET_FILTERS);
export const setLocalPagination = createAction(types.SET_PAGINATION);
export const getLocalListError = createAction(types.GET_LIST_ERROR);



// WEBPACK FOOTER //
// ./src/infraMonitor/localActions.js